// This file is part of Pollaris.
// Copyright 2024-2026 Marien Fressinaud
// Copyright 2026 Daniel Yepez Garces
// SPDX-License-Identifier: AGPL-3.0-or-later
//
// Modified by Daniel Yepez Garces on 2026-04-15:
// - Migrated database backend from PostgreSQL to MariaDB for Toolforge deployment
// - Added Wikimedia login support
// - Removed local username/password authentication
// - Added multilingual survey support
// - Added user timezone display for survey times when different from server UTC

export default function (text) {
    text = text.replaceAll('&', '&amp;');
    text = text.replaceAll('<', '&lt;')
    text = text.replaceAll('>', '&gt;')
    text = text.replaceAll('"', '&quot;')
    text = text.replaceAll("'", '&#039;');
    return text;
}
